import React from 'react';
import styles from './style.module.css';

const Card = ({ children, noPadding, padding25, overflowVisible }) => {
  return (
    <div className={`${styles.wrapper} ${noPadding ? styles.noPadding : ''} ${padding25 ? styles.padding25 : ''} ${overflowVisible ? styles.overflowVisible : ''}`}>
      { children }
    </div>
  )
}

export default Card;
